var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M339.237-33.772h408.177v294.351H339.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m352.744 129.509-20.105-29.486h-27.224l12.562 29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m305.415 100.023 12.562 29.486h-62.131l12.562-29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m286.911 227.49-31.065-97.981h62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M332.639 100.023h-27.224l12.562 29.486h34.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M317.977 129.509h-62.131l12.562-29.486h37.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M255.846 129.509h62.131l-31.066 97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M317.977 129.509h34.767l-20.105-29.486h-27.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M268.408 100.023h37.007l12.562 29.486h-62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m317.977 129.509-31.066 97.981-31.065-97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M97.761 372.257c13.443 14.542 80.258 10.062 93.346 0s11.141-85.514 0-93.346-84.422-10.972-93.346 0c-8.925 10.973-13.443 78.804 0 93.346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m596.527 242.69-25.634-80.849h-28.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m622.16 161.841-25.633 80.849-25.634-80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m596.527 80.859 25.633 80.849h28.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m570.893 161.708 25.634-80.849 25.633 80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M253.01 353.699v-28.433l34.629-42.986 18.091 52.979-11.465 37.397-24.638 18.014z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#005800",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 45,
      lineHeight: "100%",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#005800",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-67.876 198.37q.08-.12.24-.12.32 0 1.76.96 1.32.8 2.12 1.84.4.52.4 1.64 0 1.32-.68 1.48-.12.04-.24.04-.52 0-.8-.36-.8-1-2.64-4.52-.24-.48-.24-.72 0-.12.08-.24M-67.676 207.29l-3.32.44q-.2.04-.52.04-.6 0-1.16-.4-.96-.72-.96-.92 0-.16.28-.24.24-.08 3.04-.36 1.88-.16 4.48-.52l.32-.04.32-.04q1.84-.24 4.36-.68.2-.04.48-.04.6 0 1.48.44 1 .52 1 .92 0 .44-1.44.52-.56.04-3.64.36-.8.12-1.96.2l-.84.08q.64.68.64 1.08 0 .24-.16.44-.04.16-.12.44-.12.36-.2.68-.28.92-.48 2.16l1.2-.12 1.68-.24q.56-.24.96-.24.48 0 1.52.72 1 .72 1 1.04 0 .4-.2.76-.84 1.84-1.32 5.08-.84 5.24-2.32 7-1.32 1.56-2.28 1.56-.08 0-.12-.04-.48-.2-.76-.96-.84-1.68-2.36-2.84-.32-.28-.32-.48.04-.08.04-.12.04-.08.16-.08.52 0 1.76.56.52.24 1.04.4.12.04.28.04 1 0 1.64-1.28.72-1.44 1.44-4.6.44-2.08.44-3.56 0-1-.44-1.24-.32-.2-.88-.2-.08 0-.52.08-.92.16-1.44.16h-.24q-.08 0-.28-.12-1.72 6.48-5.08 9.88l-1.44 1.28q-.48.44-.92.44-.24 0-.24-.12 0-.04.04-.12.04-.12.28-.44 2.36-3 3.88-6.76 1.68-4.28 2.2-8.64v-.32q.04-.36.04-.4l-.04-.16q0-.04.04-.12.12-.2-.04-.36",
    style: {
      fontSize: 40,
      fontFamily: "TPKaisho-GT01",
      InkscapeFontSpecification: "TPKaisho-GT01",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#005800",
      fillOpacity: 1
    },
    transform: "matrix(1.19604 0 0 1.4416 94.09 -281.804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.276 203.29q-2.56 4.84-5.12 7.52-1.44 1.52-1.96 1.56-.16 0-.16-.08 0-.4.4-.88 3.04-4.56 4.52-8.24.88-2.2 1-4.76-.16-.28-.16-.48 0-.36.4-.36h.2q1.04 0 2.24 1 .64.56.64.96 0 .24-.2.52-.48.72-1.16 2.04 3.6 4.48 6.08 6.48 1.88 1.36 4.08 2.48 1.12.56 1.12.96 0 .24-.84.28h-.28q-.32.04-.6.04h-.2q-.24 0-1.6-.04-2.28-.08-3.08-.56-1.04-.64-5.32-8.44M-54.636 212.97q.12-.16.28-.16.2 0 1.88.92 1.8.96 2.84 2.08.76.8.76 1.92v.2q0 1.24-.88 1.24-.6 0-2.24-2.04-2.64-3.28-2.68-3.96v-.08q0-.04.04-.12M-54.956 221.25q.48.16 2.12.88.28.12.6.24 2.4 1 2.88 1.88.72 1.24.72 2.44 0 1-.88 1h-.12q-.44-.08-1.96-1.84-1.36-1.48-3.4-3.36-.4-.36-.4-.92 0-.36.24-.36.04 0 .12.04z",
    style: {
      fontSize: 40,
      fontFamily: "TPKaisho-GT01",
      InkscapeFontSpecification: "TPKaisho-GT01",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#005800",
      fillOpacity: 1
    },
    transform: "matrix(1.19604 0 0 1.4416 94.09 -281.804)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsi);
export default __webpack_public_path__ + "static/media/psi.a7a6273e8a497bab8e39e08a0f972cf4.svg";
export { ForwardRef as ReactComponent };